import {
  DeckTag,
  DeckTagListResposne,
  DeckTagRelation,
  DeckTagRelationListResponse,
} from 'services/apiTypes/deckTag.types'

import { RequestService } from 'services/request.service'

export class DeckTagService extends RequestService {
  list = async (query = ''): Promise<DeckTagListResposne> => {
    return super.get(`/api/decks/tags/v2/?q=${query}`)
  }

  create = async (tag: DeckTag): Promise<DeckTag> => {
    return super.post(`/api/decks/tags/`, tag)
  }

  update = async (tag: DeckTag): Promise<DeckTag> => {
    return super.patch(`/api/decks/tags/${tag.id}/`, tag)
  }

  remove = async (tagId: string | number): Promise<void> => {
    return super.delete(`/api/decks/tags/${tagId}/`, undefined, true)
  }

  getTags = async (deckId: string | number): Promise<DeckTagRelationListResponse> => {
    return super.get(`/api/decks/${deckId}/tagRelations/`)
  }

  createDeckRelation = async (
    deckId: string | number,
    tagId: string | number,
    position: string,
  ): Promise<DeckTagRelation> => {
    const res = await super.post(`/api/decks/tagRelations/`, { deck: deckId, tag: tagId, position: position })

    return {
      id: res.id,
      name: res.name,
      deckId: res.deck,
      tagId: res.tag,
      position: res.position,
    }
  }

  updateDeckRelation = async (body: DeckTagRelation): Promise<DeckTagRelation> => {
    const res = await super.patch(`/api/decks/tagRelations/${body.id}/`, { position: body.position })

    return { ...body, position: res.position }
  }

  removeDeckRelation = async (relationId: string | number): Promise<void> => {
    return super.delete(`/api/decks/tagRelations/${relationId}/`, undefined, true)
  }
}

const deckTagService = new DeckTagService()

export default deckTagService
